import { Link } from "react-router-dom";
import { Mail, Phone, MapPin } from "lucide-react";
import { SITE } from "../lib/site";
import { Logo } from "./Logo";
import { useSiteSettings } from "../lib/settings";
import { useContent } from "../lib/content";

export const Footer = () => {
  const { settings } = useSiteSettings();
  const f = useContent("footer");
  const c = {
    address: settings?.address || SITE.contact.address,
    phone: settings?.phone || SITE.contact.phone,
    email: settings?.email || SITE.contact.email,
  };
  return (
    <footer data-testid="site-footer" className="bg-[#1A1A1A] text-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-8 py-20 grid grid-cols-1 md:grid-cols-12 gap-12">
        <div className="md:col-span-4">
          <Logo variant="dark" className="h-28 lg:h-32" />
          <p className="mt-6 text-sm text-gray-300 leading-relaxed max-w-xs">
            {f.description}
          </p>
          <div className="mt-6 flex items-center gap-2 text-xs tracking-[0.2em] uppercase text-[#E60000] font-semibold">
            <span className="inline-block w-8 h-px bg-[#E60000]" />
            {f.slogan}
          </div>
        </div>

        <div className="md:col-span-3">
          <h4 className="text-xs tracking-[0.2em] uppercase text-gray-400 font-semibold mb-5">Navigation</h4>
          <ul className="space-y-3 text-sm">
            <li><Link data-testid="footer-link-accueil" to="/" className="hover:text-[#E60000] transition-colors">Accueil</Link></li>
            <li><Link data-testid="footer-link-entreprise" to="/entreprise" className="hover:text-[#E60000] transition-colors">L'Entreprise</Link></li>
            <li><Link data-testid="footer-link-metiers" to="/metiers" className="hover:text-[#E60000] transition-colors">Nos Métiers</Link></li>
            <li><Link data-testid="footer-link-realisations" to="/realisations" className="hover:text-[#E60000] transition-colors">Réalisations</Link></li>
            <li><Link data-testid="footer-link-contact" to="/contact" className="hover:text-[#E60000] transition-colors">Contact</Link></li>
          </ul>
        </div>

        <div className="md:col-span-3">
          <h4 className="text-xs tracking-[0.2em] uppercase text-gray-400 font-semibold mb-5">Coordonnées</h4>
          <ul className="space-y-4 text-sm text-gray-300">
            <li className="flex items-start gap-3"><MapPin className="w-4 h-4 mt-0.5 text-[#E60000]" strokeWidth={1.5} /><span>{c.address}</span></li>
            <li className="flex items-center gap-3"><Phone className="w-4 h-4 text-[#E60000]" strokeWidth={1.5} /><a href={`tel:${c.phone.replace(/\s/g, '')}`} className="hover:text-white">{c.phone}</a></li>
            <li className="flex items-center gap-3"><Mail className="w-4 h-4 text-[#E60000]" strokeWidth={1.5} /><a href={`mailto:${c.email}`} className="hover:text-white">{c.email}</a></li>
          </ul>
        </div>

        <div className="md:col-span-2">
          <h4 className="text-xs tracking-[0.2em] uppercase text-gray-400 font-semibold mb-5">Légal</h4>
          <ul className="space-y-3 text-sm">
            <li><Link data-testid="footer-mentions" to="/mentions-legales" className="text-gray-300 hover:text-[#E60000]">Mentions légales</Link></li>
            <li><Link data-testid="footer-privacy" to="/confidentialite" className="text-gray-300 hover:text-[#E60000]">Confidentialité</Link></li>
          </ul>
        </div>
      </div>
      <div className="border-t border-white/10">
        <div className="max-w-7xl mx-auto px-6 lg:px-8 py-6 flex flex-col md:flex-row items-center justify-between gap-3 text-xs text-gray-400">
          <span>© {new Date().getFullYear()} {SITE.legalName}. {f.copyright_suffix}</span>
          <span>{f.credits}</span>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
